export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8516.f1e2f422.jpg";